import React from "react";

export default function ChartCard({ title, subtitle, right, children, className = "", testId }) {
  return (
    <div
      data-testid={testId}
      className={[
        "flex flex-col rounded-md border border-slate-200 bg-white shadow-sm transition-shadow hover:shadow-md",
        className,
      ].join(" ")}
    >
      <div className="flex items-center justify-between border-b border-slate-100 px-5 py-4">
        <div>
          <div className="font-display text-base font-semibold tracking-tight text-navy-600">
            {title}
          </div>
          {subtitle && <div className="mt-0.5 text-xs text-slate-500">{subtitle}</div>}
        </div>
        {right}
      </div>
      <div className="flex-1 p-5">{children}</div>
    </div>
  );
}
